import { css } from 'styled-components';
import {
    PURPLE_LIGHT, GRAY, PURPLE_LIGHTER, SEARCH_HIGHLIGHT, PINK
  } from '../../../../constants/colors';

export default {
    buttonWrapper: css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 25px;
    border-bottom: 1px solid ${GRAY};
  `,
};